"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = exports.POPUP_SELECT = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const react_2 = require("react");
exports.POPUP_SELECT = {
    cta: true,
    ctaText: true,
    image: true,
    description: true,
    title: true,
};
const TTL = (0, utils_1.parseTime)('1h');
function Popup({ children, modalOptions, timeout = (0, utils_1.parseTime)('10s'), }) {
    const [value, setValue] = (0, app_1.useLocalStorage)('popup');
    const [ready, setReady] = (0, react_2.useState)(false);
    const { data } = (0, app_1.useQuery)('getPopup', {
        select: exports.POPUP_SELECT,
    });
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            if (!value || Date.now() > Number(value)) {
                setReady(true);
                setValue(String(Date.now() + TTL));
            }
        }, timeout);
    }, [setValue, timeout, value]);
    if (!data) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(app_1.AssetsProvider, Object.assign({ path: `/popup/${data.id}` }, { children: (0, jsx_runtime_1.jsx)(app_1.Context, Object.assign({ name: "popup" }, { children: (0, jsx_runtime_1.jsx)(ui_1.Modal, Object.assign({ open: ready, options: Object.assign({ closeOnBackgroundClick: true }, modalOptions), onClose: () => setReady(false) }, { children: children(data) })) })) })));
}
exports.Popup = Popup;
